<template>
  <v-container fluid>
    <!-- <el-overlay-loading :loading="pageloading" /> -->
    <h3 class="mb-4">Ataskaitos</h3>

    <v-row>
      <v-col cols="12">
        <v-tabs v-model="ataskaitaTab" dense>
          <v-tabs-slider color="primary"></v-tabs-slider>
          <v-tab
            class="ataskaita-tab"
            v-for="item in ataskaitaList"
            :key="item.value"
            link
            :to="{ name: item.routeName }"
          >
            <h4>{{ item.label }}</h4>
          </v-tab>
        </v-tabs>
      </v-col>
    </v-row>

    <template v-if="isAtaskaita">
      <ataskaita-search
        class="mt-1 mb-1"
        :key="ataskaitaSearchKey"
        :loading="loadingList"
        :tab-item="ataskaitaTabItem"
        @search="searchAtaskaita"
      />

      <v-data-table
        :headers="filteredHeaders"
        :items="itemsList"
        :search="search"
        :footer-props="{
          showFirstLastPage: true,
          showCurrentPage: true,
          itemsPerPageText: 'Rodyti po:',
          itemsPerPageAllText: 'visi',
          itemsPerPageOptions: itemsPerPageOptions,
        }"
        :hide-default-footer="hideFooter"
        :sort-by.sync="pagination.sort"
        :sort-desc.sync="pagination.sortDesc"
        :server-items-length="pagination.total"
        :items-per-page="pagination.pageSize"
        :page.sync="pagination.page"
        @update:options="updatePagination"
      >
        <template #top>
          <v-toolbar flat>
            <v-spacer></v-spacer>
            <el-button-prideti
              primary
              @click.native.stop="openAtaskaitaModal()"
            >
              Formuoti
            </el-button-prideti>
          </v-toolbar>
        </template>
        <template #[`item.ata_busena_title`]="{ item }">
          <el-busena
            :busena="item.ata_busena_title"
            :color="item.busenaColor"
          />
        </template>
        <template #[`item.pai_duomenu_naudojimo_tikslas`]="{ item }">
          <div class="text-cut-4">
            {{ item.pai_duomenu_naudojimo_tikslas }}
          </div>
        </template>
        <template #[`item.ataskaita`]="{ item }">
          <div class="nowrap">
            <template v-if="!item.noData">
              <el-byla
                v-for="byla in item.bylos"
                :key="byla.byl_id"
                :byla="byla"
              />
            </template>
            <template v-if="item.noData">
              Duomenų nėra
            </template>
          </div>
        </template>
        <template #[`item.actions`]="{ item }">
          <div class="nowrap">
            <el-table-action :item="item" @dvsItem="dvsItem(item)" />
          </div>
        </template>
        <template slot="loading">
          Kraunasi...
        </template>
        <template slot="no-results">
          Duomenų nėra
        </template>
        <template slot="no-data">
          Duomenų nėra
        </template>
        <template #[`footer.page-text`]="props">
          Rodoma {{ props.pageStart }}-{{ props.pageStop }} iš
          {{ props.itemsLength }}
        </template>
      </v-data-table>
      <div class="disclaimer mt-4 mb-2"></div>
    </template>

    <modal-ataskaita
      :key="modalAtaskaitaKey"
      :tab-item="ataskaitaTabItem"
      v-model="showModal"
      @savedData="savedAtaskaita"
    />
    <modal-confirm
      :title="confirmTitle"
      :text="confirmText"
      :item="confirmItem"
      :action="confirmAction"
      v-model="showConfirm"
      @confirmResend="confirmResend"
      @cancelConfirm="cancelConfirm"
    />
    <modal-ataskaita-send-kitas
      :item="modalSendKitasItem"
      v-model="showSendKitas"
      @confirmSendKitas="confirmSendKitas"
    />
    <modal-ataskaita-registrai-dvs
      :key="modalDvsKey"
      :item="modalDvsItem"
      v-model="showDvs"
      @confirmDvs="confirmDvs"
    />
  </v-container>
</template>

<script>
import math from '../../mixins/math'
import AtaskaitaSearch from './AtaskaitaSearch'
import ModalAtaskaita from '../modals/ModalAtaskaita'
import ModalAtaskaitaRegistraiDvs from '../modals/ModalAtaskaitaRegistraiDvs'
import ModalConfirm from '../modals/ModalConfirm'
import ModalAtaskaitaSendKitas from '../modals/ModalAtaskaitaSendKitas'

export default {
  name: 'Ataskaita',
  components: {
    ModalAtaskaita,
    ModalAtaskaitaRegistraiDvs,
    ModalConfirm,
    ModalAtaskaitaSendKitas,
    AtaskaitaSearch,
  },
  mixins: [math],
  data() {
    return {
      ataskaitaTab: null,

      pageloading: true,
      loading: false,
      loadingList: false,
      searchData: {},
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0,
        totalPages: 0,
        sort: null,
        sortDesc: [],
        direction: 'asc',
      },
      paginationloading: true,

      search: null,
      itemsPerPageOptions: [10, 50, 100],

      ataskaitos: [],

      showModal: false,
      modalAtaskaitaRefresh: 0,

      lockInterval: null,
      lockTimeout: 5000,

      showConfirm: false,
      confirmTitle: null,
      confirmText: null,
      confirmItem: null,
      confirmAction: null,

      modalSendKitasItem: {},
      showSendKitas: null,

      modalDvsItem: {},
      modalDvsRefresh: 0,
      showDvs: null,
    }
  },
  computed: {
    defaultAtaskaitaList() {
      return [
        {
          label: 'Susijusiems registrams',
          modalLabel: 'Ataskaitos susijusiems registrams formavimas',
          routeName: 'ataskaitaSusijusiems',
          registrams: true,
          statistika: false,
          stsr: false,
          ntr: false,
          ntrpaslaugos: false,
          tipas: 'registrams',
          value: 1,
        },
        {
          label: 'Statistika STSR',
          modalLabel: 'Statistikos ataskaitos STSR formavimas',
          routeName: 'ataskaitaStsr',
          registrams: false,
          statistika: true,
          stsr: true,
          ntr: false,
          ntrpaslaugos: false,
          tipas: 'stsr',
          value: 2,
        },
        {
          label: 'Statistika NTR',
          modalLabel: 'Statistikos ataskaitos NTR formavimas',
          routeName: 'ataskaitaNtr',
          registrams: false,
          statistika: true,
          stsr: false,
          ntr: true,
          ntrpaslaugos: false,
          tipas: 'ntr',
          value: 3,
        },
        {
          label: 'NEP naudojamumas',
          modalLabel: 'NEP naudojamumo ataskaitos formavimas',
          routeName: 'ataskaitaNep',
          registrams: false,
          statistika: false,
          stsr: false,
          ntr: false,
          ntrpaslaugos: true,
          tipas: 'ntrpaslaugos',
          value: 4,
        },
      ]
    },
    headers() {
      return [
        {
          text: 'Ataskaitos Nr.',
          align: 'start',
          value: 'ata_id',
        },
        {
          text: 'Ataskaitos suformavimo data ir laikas',
          align: 'start',
          value: 'ata_busenos_data',
        },
        {
          text: 'Laikotarpis nuo',
          align: 'start',
          value: 'ata_laikotarpis_nuo',
        },
        {
          text: 'Laikotarpis iki',
          align: 'start',
          value: 'ata_laikotarpis_iki',
        },
        {
          text: 'Suformavimo būsena',
          align: 'start',
          value: 'ata_busena_title',
        },
        {
          text: 'Susijusio registro objektas',
          align: 'start',
          value: 'ata_tipas',
          hide: !this.ataskaitaTabItem.registrams,
        },
        {
          text: 'Ataskaitą suformavo',
          align: 'start',
          value: 'suformavo',
        },
        {
          text: 'DVS Nr.',
          align: 'start',
          value: 'ata_dvs_nr',
          hide: !this.ataskaitaTabItem.registrams,
        },
        {
          text: 'Išsiuntimo DVS data',
          align: 'start',
          value: 'ata_dvs_data',
          hide: !this.ataskaitaTabItem.registrams,
        },
        {
          text: 'Ataskaita',
          align: 'start',
          sortable: false,
          value: 'ataskaita',
        },
        {
          text: 'Veiksmai',
          align: 'start',
          sortable: false,
          value: 'actions',
          hide: !this.ataskaitaTabItem.registrams,
        },
      ]
    },
    filteredHeaders() {
      return this.headers.filter(item => {
        return !item.hide
      })
    },
    ataskaitaList() {
      return this.defaultAtaskaitaList.filter(item => {
        return !item.hide
      })
    },
    itemsList() {
      return this.ataskaitos.map((item, index) => {
        item.ata_el_pastas_text = item.ata_el_pastas.join(', ')

        item.bylos = item.bylos.map(byla => {
          byla.byl_tipas = `${byla.byl_tipas}_${byla.ext}`
          byla.byl_pavadinimas = `${item.ata_id} ${
            this.ataskaitaTabItem.statistika ? 'Statistika ' : ''
          } ${item.ata_tipas} ${byla.byl_dokumento_data} ${
            byla.papildomas_tekstas
          }${byla.ext === 'docx' ? ' (word)' : ''}${
            byla.ext === 'xlsx' ? ' (excel)' : ''
          }`
          byla.byl_url = `byla/${byla.byl_id}/${byla.byl_hash}/content`
          return byla
        })

        if (item.ata_busena === 'suformuota') {
          item.cansendKitas = false
          item.canResend = false
          item.canDvs = true
          if (item.bylos.length === 0) {
            item.noData = true
          }
        }

        return item
      })
    },
    hideFooter() {
      return this.pagination.total <= 10
    },
    isVykdoma() {
      return (
        this.ataskaitos.filter(item => item.ata_busena === 'formuojama')
          .length > 0
      )
    },
    isLocal() {
      return (
        process.env.VUE_APP_LOCAL === 'local' ||
        process.env.VUE_APP_LOCAL === 'develop' ||
        process.env.VUE_APP_LOCAL === 'test'
      )
    },
    modalAtaskaitaKey() {
      return 'ataskaita' + this.modalAtaskaitaRefresh
    },
    modalDvsKey() {
      return 'dvs' + this.modalDvsRefresh
    },
    ataskaitaTabItem() {
      return this.ataskaitaList.find(
        element => element.routeName === this.$route.name
      )
    },
    ataskaita() {
      return this.ataskaitaTabItem.value
    },
    isAtaskaita() {
      return this.ataskaita
    },
    ataskaitaSearchKey() {
      return `ataskaitasearch-${this.ataskaitaTabItem.value}`
    },
  },
  beforeDestroy() {
    this.stopLoading()
  },
  created() {
    //this.checkLoading()
  },
  methods: {
    searchAtaskaita(searchData) {
      this.searchData = searchData
      this.getData()
    },
    getData(silent = false) {
      // this.searchData = searchData
      this.loadingList = !silent

      if (!silent) {
        this.pagination.page = 1
      }

      const data = {
        ...this.pagination,
        tipas: this.ataskaitaTabItem.tipas,
        search: { ...this.searchData },
      }
      this.$axios
        .post(`ataskaita`, data)
        .then(res => {
          this.ataskaitos = res.data.ataskaitos
          this.pagination = { ...this.pagination, ...res.data.pagination }
          this.checkLoading()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.pageloading = false
          this.loadingList = false
          this.paginationloading = false
          this.showList = true
        })
    },
    updatePagination(pagination) {
      if (this.paginationloading) {
        return
      }
      this.paginationloading = true
      this.pagination.page = pagination.page
      this.pagination.pageSize = pagination.itemsPerPage
      this.pagination.sort = pagination.sortBy[0]
      this.pagination.sortDesc = pagination.sortDesc
      this.pagination.direction = pagination.sortDesc[0] ? 'desc' : 'asc'

      if (!this.loadingList) {
        this.getData(true)
      }
    },
    checkLoading() {
      if (this.isVykdoma) {
        if (!this.lockInterval) {
          this.lockInterval = setInterval(() => {
            this.updateList()
          }, this.lockTimeout)
        }
      } else {
        this.stopLoading()
      }
    },
    stopLoading() {
      clearInterval(this.lockInterval)
    },
    updateList() {
      this.getData(this.searchData, true)
    },
    openAtaskaitaModal() {
      this.modalAtaskaitaRefresh++
      this.showModal = true
    },
    savedAtaskaita() {
      this.pagination.page = 1
      this.updateList()
    },
    resendItem(item) {
      this.confirmTitle = `Pakartoti siuntimą`
      this.confirmText = `Ar norite pakartoti ataskaitos siuntimą?`
      this.confirmAction = 'Resend'
      this.confirmItem = item
      this.showConfirm = true
    },
    confirmResend(item) {
      this.$axios
        .post(`ataskaita/${item.ata_id}/kartoti`)
        .then(res => {
          window._VMA.$emit('DATA_OK', res.data.message)
          this.updateList()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
    },
    cancelConfirm() {
      //
    },
    sendKitasItem(item) {
      this.modalSendKitasItem = item
      this.showSendKitas = true
    },
    confirmSendKitas(payload) {
      const data = {
        ata_id: payload.item.ata_id,
        ata_el_pastas: payload.pastai,
      }
      this.$axios
        .post(`ataskaita/${payload.item.ata_id}/siusti`, data)
        .then(res => {
          window._VMA.$emit('DATA_OK', res.data.message)
          this.updateList()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
    },
    dvsItem(item) {
      this.modalDvsRefresh++
      this.modalDvsItem = Object.assign({}, item)
      this.showDvs = true
    },
    confirmDvs(item) {
      const data = {
        ata_id: item.ata_id,
        ata_dvs_nr: item.ata_dvs_nr,
        ata_dvs_data: item.ata_dvs_data,
      }
      this.$axios
        .post(`ataskaita/${item.ata_id}`, data)
        .then(res => {
          window._VMA.$emit('DATA_OK', res.data.message)
          this.updateList()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.showDvs = false
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.disclaimer {
  color: rgba(0, 0, 0, 0.6);
  font-size: 0.875rem;
  font-weight: 400;
}
.ataskaita-tab {
  max-width: 300px;
}
</style>
